import { css } from '@emotion/css';
import { alpha, Theme } from '@mui/material/styles';

const iconContainer = (theme: Theme, isEmailConfirmed: boolean) =>
  css({
    '&.MuiBox-root': {
      margin: '0 auto 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      position: 'relative',
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      backgroundColor: alpha(
        isEmailConfirmed
          ? theme.palette.success.main
          : theme.palette.primary.light,
        0.25
      ),
      color: isEmailConfirmed
        ? theme.palette.success.main
        : theme.palette.primary.light,
    },
  });

const awesomeIcon = css({
  '&.MuiSvgIcon-root': {
    fontSize: '20px',
    position: 'absolute',
    top: '0',
    right: '0',
  },
});

const getValidateAccountStyles = (theme: Theme, isEmailConfirmed: boolean) => ({
  iconContainer: iconContainer(theme, isEmailConfirmed),
  awesomeIcon,
});

export default getValidateAccountStyles;
